<template>
    <div class="page-header container row between mb-20">
        <div class="row">
            <back-button :onRoute="onRoute" v-if="back" />
            <h3 class="page-title" :class="{'pad': !!back}">
                {{ title }}
            </h3>
        </div>
        <div>
            <span v-for="(command, index) in commands" :key="index">
                <router-link
                    v-if="command.to"
                    :to="command.to"
                    class="btn command-btn"
                    :class="{
                        'icon': command.icon,
                        [command.type || 'green']: true
                    }"
                    
                >
                    <span v-if="command.icon">{{ command.icon }}</span>
                    {{ command.text }}
                </router-link>
                <button
                    v-else
                    @click="command.click"
                    class="btn command-btn"
                    :class="{
                        'icon': command.icon,
                        [command.type || 'green']: true
                    }"
                    
                >
                    <span v-if="command.icon">{{ command.icon }}</span>
                    {{ command.text }}
                </button>
            </span>
        </div>
    </div>
</template>

<script>
import BackButton from './BackButton.vue'
export default {
    props: ['title', 'back', 'onRoute', 'commands'],
    components: { BackButton }
}
</script>

<style lang='scss' scoped>
.page-header {
    margin: 0 auto 3px auto;
    align-items: center;
    padding: 23px 0 5px 0; 
    & > div { 
        .page-title {
            margin: 4px 0 0 0;
            padding: 0;
            &.pad {
                padding-left: 10px;
            }
        }
        .command-btn {
            padding-right: 20px;
            transition: padding .2s;
            margin: 3px;
            &:hover {
                padding-right: 15px;
            }
        }
    }
    
    @media screen and (max-width: 400px) {
        flex-direction: column; 
        & > div {
            .page-title {
                margin-bottom: 20px;
            }
            .command-btn {
                padding: 8px 10px;
                margin: 3px;
                span {
                    display: none;
                }
            }
        }
    }
}
</style>